import { httpClient, HttpMethod } from './http-client';
import { ZonesResponse } from '../@types/geosocial.type';
import {
  StructureStatesResponse,
  StatesWithCountryResponse,
  RegionSuburbsResponse,
} from '../@types/structure.type';

export const getStates = (): Promise<StructureStatesResponse[]> => {
  return httpClient<StructureStatesResponse[]>('/states', HttpMethod.Get);
};

export const getStateWithCountryData = (stateId: number): Promise<StatesWithCountryResponse> => {
  return httpClient<StatesWithCountryResponse>(`/states/${stateId}/country`, HttpMethod.Get);
};

export const getZones = (): Promise<ZonesResponse[]> => {
  return httpClient<ZonesResponse[]>('/zones', HttpMethod.Get);
};

export const getSuburbsByPostcode = (postcode: string): Promise<RegionSuburbsResponse[]> => {
  return httpClient<RegionSuburbsResponse[]>(`/suburbs/postcode/${postcode}`, HttpMethod.Get);
};
